import React, { useMemo } from 'react'
import { useNewTranslation } from 'hooks'
import { BaseEditorContainer } from './styles'
import { TASK_TYPE_ENUM } from 'services/api/constants'
import InputField from 'components/Shared/Fields'
import Divider from 'components/Shared/Divider'
import Text from 'particles/Text'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'

interface TaskSetUpEditorProps {
    type: TASK_TYPE_ENUM
    className?: string
    taskUuid: string
}

const TaskSetUpEditor: React.FC<TaskSetUpEditorProps> = ({ type, className, taskUuid }) => {
    const [t] = useNewTranslation()

    const { title, titlePlaceholder } = useMemo(() => {
        let key = '',
            titlePlaceholderKey = ''
        switch (type) {
            case TASK_TYPE_ENUM.PURCHASE_PRODUCT:
                key = 'campaignEditor.createTask.setUpProductPurchase.pageTitle'
                titlePlaceholderKey = 'placeholderText.textField.enterStepTitlePurchaseProduct'
                break
            case TASK_TYPE_ENUM.ATTEND_EVENT:
                key = 'campaignEditor.createTask.createAttendEventTitle'
                titlePlaceholderKey = 'taskType.attendEvent'
                break
            case TASK_TYPE_ENUM.IG_POST:
            case TASK_TYPE_ENUM.IG_POST_V02:
                key = 'campaignEditor.createTask.createInstagramPostTitle'
                titlePlaceholderKey = 'sidebar.campaignEditor.instagramPost'
                break
            case TASK_TYPE_ENUM.IG_STORY:
            case TASK_TYPE_ENUM.IG_STORY_V02:
                key = 'campaignEditor.createTask.createInstagramStoryTitle'
                titlePlaceholderKey = 'taskType.instagramStory'
                break
            case TASK_TYPE_ENUM.IG_REEL:
                key = 'campaignEditor.createTask.createInstagramReelTitle'
                titlePlaceholderKey = 'taskType.instagramReel'
                break
            case TASK_TYPE_ENUM.FB_POST:
            case TASK_TYPE_ENUM.FB_POST_V02:
                key = 'campaignEditor.createTask.createFacebookPostTitle'
                titlePlaceholderKey = 'taskType.facebook'
                break
            case TASK_TYPE_ENUM.TIKTOK_POST:
                key = 'campaignEditor.createTask.createTikTokTitle'
                titlePlaceholderKey = 'socialMedia.platform.TikTok'
                break
            case TASK_TYPE_ENUM.XIAOHONGSHU_POST:
                key = 'campaignEditor.createTask.createXHSPostTitle'
                titlePlaceholderKey = 'taskType.xiaohongshuPost'
                break
        }

        return { title: t(key), titlePlaceholder: t(titlePlaceholderKey) }
    }, [t, type])
    return (
        <BaseEditorContainer className={className}>
            <Text scale="H4" color="primary">
                {title}
            </Text>
            <Divider maxWidth="1006px" className="first-divider" />
            <div className="title-input-field">
                <CampaignEditorInputFieldContainer>
                    <InputField.TextInputField
                        className={'input-area'}
                        label={t('campaignEditor.createTask.enterTitleHeader')}
                        placeholder={titlePlaceholder}
                        name="title"
                        showInputLength
                        maxInputLength={150}
                        isRequired
                        width="100%"
                        identifier={`${taskUuid}_${fieldIdentifiers.setupTitle}`}
                    />
                    <InputField.TextAreaField
                        label={t('campaignEditor.createTask.enterDescriptionHeader')}
                        name="description"
                        width="100%"
                        minTextAreaHeight={112}
                        identifier={`${taskUuid}_${fieldIdentifiers.setupDescription}`}
                    />
                </CampaignEditorInputFieldContainer>
            </div>
        </BaseEditorContainer>
    )
}
export default styled(TaskSetUpEditor)`
    min-height: 100%;
    height: fit-content;
    .title-input-field {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.l};
    }
`
